import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// components
import { DynamicFormBuilderComponent } from './dynamic-form-builder.component';
import { FieldBuilderComponent } from './field-builder/field-builder.component';
import { TextBoxComponent } from './atoms/textbox';
import { DropDownComponent } from './atoms/dropdown';
import { CheckBoxComponent } from './atoms/checkbox';
import { RadioComponent } from './atoms/radio';
import { TextAreaComponent } from './atoms/textarea';
import { MultiSelectSearchFilter } from 'angular-2-dropdown-multiselect';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  declarations: [
    DynamicFormBuilderComponent,
    FieldBuilderComponent,
    TextBoxComponent,
    DropDownComponent,
    CheckBoxComponent,
    RadioComponent,
    TextAreaComponent,
    
    // MultiSelectSearchFilter
  ],
  exports: [DynamicFormBuilderComponent],
  providers: [],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class DynamicFormBuilderModule { }



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/dynamic-form-builder/dynamic-form-builder.module.ts